import { render, staticRenderFns } from "./AppCopyright.vue?vue&type=template&id=15395742&scoped=true&"
import script from "./AppCopyright.vue?vue&type=script&lang=js&"
export * from "./AppCopyright.vue?vue&type=script&lang=js&"
import style0 from "./AppCopyright.vue?vue&type=style&index=0&id=15395742&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15395742",
  null
  
)

export default component.exports